import { WButton } from '@alice-health/wonderland-react'
import { FunctionComponent } from 'react'
import { useMediaQuery } from '@/global/hooks'
import { useMap } from '@vis.gl/react-google-maps'

const MapContainerActions: FunctionComponent = () => {
  const map = useMap()
  const isDesktopShort = useMediaQuery({ device: 'short-desktop-height' })

  const handleZoomIn = () => {
    const zoom = map?.getZoom()
    if (!zoom) return

    map?.setZoom(zoom + 1)
  }

  const handleZoomOut = () => {
    const zoom = map?.getZoom()
    if (!zoom) return

    map?.setZoom(zoom - 1)
  }

  return (
    <div className='hidden lg:flex flex-col absolute justify-evenly bottom-8 right-gl-spacing-08 gap-gl-spacing-02'>
      <WButton
        name='zoom-in'
        icon='icAdd'
        variant='white'
        iconButton
        size={isDesktopShort ? 'medium' : 'large'}
        onClick={handleZoomIn}
      />
      <WButton
        name='zoom-out'
        icon='icDelete'
        variant='white'
        iconButton
        size={isDesktopShort ? 'medium' : 'large'}
        onClick={handleZoomOut}
      />
    </div>
  )
}

export { MapContainerActions }
